module.exports = __webpack_public_path__ + "img/auth1.e4330bc0.png";